import React from 'react';
import parse from 'html-react-parser';
import Panel from 'rsuite/Panel';

export default function OptionDropdown({
  dropdownTitle,
  dropdownContent
}) {
  return dropdownTitle && dropdownContent && (
    <Panel
      className="app-option-dropdown"
      header={dropdownTitle}
      collapsible>
      <div className="app-option-dropdown-content">{parse(dropdownContent)}</div>
    </Panel>
  )
};
